var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"xmlns":"http://www.w3.org/2000/svg","d":"M6.20001 26.3V16H0.5L8.70001 0V10.3H14.2L6.20001 26.3Z","fill":"#4689F4"}})}
var staticRenderFns = []

export { render, staticRenderFns }